module.exports = __webpack_public_path__ + "img/logo_large_en.711ff7ec.png";